/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EExperienceLevel } from "../types/EExperienceLevel.ts";

/**
 * @description 1 = Junior | 2 = MidLevel | 3 = Senior | 4 = NotApplicable |
 */
export const eExperienceLevelSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Junior | 2 = MidLevel | 3 = Senior | 4 = NotApplicable | ",
  ) as unknown as ToZod<EExperienceLevel>;
